export default __webpack_public_path__ + "static/media/asset.8dd3eb06.jpg";